import React from "react";
import '../../../styles/components/Contact.css';

const Contact = () => {
  return (
    <section id="contact-us" className="contact-us">
      <h1 className="form-heading">DON’T BE SHY, SAY HELLO!</h1>
      <div className="contact-us-container">
        <div className="form-section">
          <form className="contact-form">
            <input type="text" placeholder="Your name" className="form-input" />
            <input type="email" placeholder="Your email" className="form-input" />
            <input type="text" placeholder="Subject" className="form-input" />
            <textarea
              placeholder="Your message (optional)"
              className="form-textarea"
            ></textarea>
            <button type="submit" className="form-submit">
              Submit
            </button>
          </form>
        </div>
        <div className="info-section">
          <h2 className="info-heading">HEAD OFFICE</h2>
          <p className="info-text">6800 Jericho turnpike Suite 120w</p>
          <p className="info-text">Syosset New York 11791</p>

          <h2 className="info-heading">ISLAMABAD OFFICE</h2>

          <h2 className="info-heading">Email Us</h2>
          <p className="info-text">info@dezine95.com</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
